export default "__VITE_PUBLIC_ASSET__eb9c3b9c__"